var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('dashboard-core-app-bar',{directives:[{name:"show",rawName:"v-show",value:(_vm.isDrawer),expression:"isDrawer"}]}),_c('dashboard-core-drawer',{directives:[{name:"show",rawName:"v-show",value:(_vm.isDrawer),expression:"isDrawer"}]}),_c('Snackbars'),_c('dashboard-core-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }